module.exports = __webpack_public_path__ + "img/bitlabImg3x.756aad3d.png";